<template>
  <div class="container-fluid settings-page">
    <div class="row">
      <div class="col-12">
        <section class="settings-content-card">
          <component :is="currentSectionComponent" :title="getSectionLabel(activeSection)" />
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import SettingsAccountSection from '@/components/settings/SettingsAccountSection.vue';
import SettingsMfaSection from '@/components/settings/SettingsMfaSection.vue';
import SettingsRfcsSection from '@/components/settings/SettingsRfcsSection.vue';
import SettingsChangePasswordSection from '@/components/settings/SettingsChangePasswordSection.vue';
import SettingsSubscriptionSection from '@/components/settings/SettingsSubscriptionSection.vue';
import SettingsBillingSection from '@/components/settings/SettingsBillingSection.vue';
import SettingsPlaceholderSection from '@/components/settings/SettingsPlaceholderSection.vue';
import accountService from '@/services/account';

export default {
  name: 'SettingsPage',
  components: {
    SettingsAccountSection,
    SettingsMfaSection,
    SettingsRfcsSection,
    SettingsChangePasswordSection,
    SettingsSubscriptionSection,
    SettingsBillingSection,
    SettingsPlaceholderSection,
  },
  data() {
    return {
      activeSection: 'account',
      sections: [
        { key: 'account', label: 'Mi Cuenta' },
        { key: 'billing', label: 'Facturación' },
        { key: 'subscription', label: 'Mi Suscripción' },
        { key: 'rfcs', label: 'Mis RFCs' },
        { key: 'password', label: 'Mi Contraseña' },
      ],
    };
  },
  mounted: async function() {
    await this.resolveInitialSection();
  },
  watch: {
    '$route.query.section': {
      immediate: true,
      handler() {
        const sectionFromRoute = this.getSectionFromRoute();

        if (sectionFromRoute) {
          this.activeSection = sectionFromRoute;
        }
      },
    },
  },
  computed: {
    currentSectionComponent() {
      if (this.activeSection === 'account') return 'SettingsAccountSection';
      if (this.activeSection === 'security') return 'SettingsMfaSection';
      if (this.activeSection === 'subscription') return 'SettingsSubscriptionSection';
      if (this.activeSection === 'billing') return 'SettingsBillingSection';
      if (this.activeSection === 'rfcs') return 'SettingsRfcsSection';
      if (this.activeSection === 'password') return 'SettingsChangePasswordSection';
      return 'SettingsPlaceholderSection';
    },
  },
  methods: {
    getSectionFromRoute() {
      const section = String(this.$route?.query?.section || '').trim();
      const sectionExists = this.sections.some((item) => item.key === section);

      return sectionExists ? section : '';
    },
    async resolveInitialSection() {
      const sectionFromRoute = this.getSectionFromRoute();
      if (sectionFromRoute) {
        this.activeSection = sectionFromRoute;
        return;
      }

      try {
        const response = await accountService.getDetails();
        const mainRfcId = response?.data?.main_rfc_id || null;

        if (!mainRfcId) {
          this.activeSection = 'rfcs';
        }
      } catch (error) {
      }
    },
    getSectionLabel(key) {
      const section = this.sections.find((item) => item.key === key);
      return section ? section.label : 'Configuración';
    },
  },
};
</script>
